// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/tick.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/green_tick.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/invalid_cross.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/down-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/cross.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video_bg1 video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  opacity: 1;
  position: fixed;
  overflow: hidden;
}
.plan_parts {
  position: relative;
  height: 100%;
}

.video_bg1 {
  position: relative;
  z-index: 1;
  height: 100%;
}

.video_bg1:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 250vh;
  z-index: 1;
}
/* .overlaybg{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.3);
    width: 100%;
    height: 100%;
    z-index: 9;
} */
.loves_travel {
  position: absolute;
  left: 0;
  top: 60px;
  right: 0;
  bottom: 0;
  z-index: 9;
  width: 100%;
  /* min-height: 600px; */
  white-space: pre-line;
}

.loves_travel_inner {
  max-width: 980px;
  width: 100%;
  margin: 0 auto;
}

.loves_travel_inner h2 {
  text-align: center;
  font-size: 46px;
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
}

.tvi_w_logo {
  text-align: center;
  margin: 20px auto;
}

.trip_membership {
  background: #fff;
  border-radius: 10px;
  padding: 60px 10px 20px 10px;
  margin-top: 30px;
  position: relative;
}
.trip_membership ._loading_overlay_overlay {
  position: absolute;
  top: -50px;
  bottom: -40px;
  height: 108%;
}
.trip_membership h2 {
  font-size: 30px;
  color: rgb(47, 46, 46);
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  margin: 0;
}

.trip_membership p {
  font-size: 30px;
  color: rgb(47, 46, 46);
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  margin: 20px 0 0 0;
}

.tvi_plan {
  margin-top: 60px;
}

.plan_container {
  margin: 0 -20px;
  display: flex;
  flex-wrap: wrap;
}

.plan_inner {
  max-width: calc(100% / 3);
  width: 100%;
  padding: 0 20px;
}

.plan_inner_inner {
  flex: 0 1 auto;
  flex-direction: column;
  height: 100%;
  border: 1px solid rgba(47, 46, 46, 0.2);
}

.trip_inner_membership {
  background: rgba(176, 55, 55, 0.1);
  padding: 30px;
  position: relative;
}
.spot {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  background: rgb(176, 55, 55);
  position: absolute;
  left: 50%;
  top: -20px;
  transform: translateX(-50%);
  white-space: nowrap;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
}
.trip_inner_membership h2 {
  text-align: center;
  color: rgb(47, 46, 46);
  font-size: 20px;
  line-height: 1.4em;
  padding-bottom: 12px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.sign_up_partts.paymnt_parttss {
  max-width: 100%;
  width: 100%;
}

.check_out_partts .paymnt_text h2 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  color: rgb(14, 223, 73);
  margin: 0;
}
.price_plan span {
  font-size: 18px !important;
  line-height: 1 !important;
  margin-right: 2px;
  vertical-align: top;
  display: inline-block;
}

.paymnt_type {
  max-width: 100%;
  width: 100%;
}
.paymn_success {
  text-align: center;
}
.paymnt_inner_type {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px 0 10px 0;
  max-width: 60%;
  margin: auto;
  width: 100%;
}

.paymnt_inner_rightts {
  text-align: right;
  font-weight: 600;
  font-size: 16px;
  color: #000;
  width: 50%;
  word-break: break-all;
}

.paymnt_inner_leftts {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: #5b5959;
  width: 50%;
}
.price_plan {
  color: rgb(47, 46, 46);
  line-height: 1.1 !important;
  font-size: 80px;
  font-weight: 300;
}

.membership_two {
  color: rgb(47, 46, 46);
  font-size: 14px !important;
  line-height: 20px !important;
  text-align: center;
  margin-top: 30px;
}

.validity {
  margin-top: 30px;
  color: rgb(176, 170, 169);
  font-size: 12px !important;
  line-height: 1 !important;
  text-align: center;
}

.lock_button {
  text-align: center;
  margin-top: 30px;
}

.lock_button_partts {
  background-color: rgba(50, 84, 102, 1);
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0);
  border-width: 1px;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
  padding: 0 10px;
  color: #fff;
  font-weight: 600;
  display: inline-block;
  font-size: 12px;
  max-width: 300px;
  width: 100%;
}

.lock_button_partts:hover {
  text-decoration: none;
  background-color: rgba(50, 84, 102, 0.7);
  color: #fff;
}

.plan_offer {
  padding: 20px;
  margin: 0px;
}

.plan_offer li {
  list-style-type: none;
  font-size: 13px;
  padding: 10px 20px 10px 20px;
  position: relative;
}

.plan_offer li:before {
  content: "";
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  left: 0;
  top: 10px;
  width: 24px;
  height: 24px;
}
.valid .form-control {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 98% center;
  background-repeat: no-repeat;
  box-shadow: 0 0 5px rgba(40, 246, 24, 0.3);
  border: 1px solid #28f618;
}

.invalid .form-control {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 98% center;
  background-repeat: no-repeat;
  box-shadow: 0 0 5px rgba(244, 11, 11, 0.3);
  border: 1px solid #f40b0b;
}
@media screen and (max-width: 991px) {
  .price_plan {
    font-size: 40px;
  }
  .trip_inner_membership {
    padding: 10px;
  }
  .lock_button_partts {
    max-width: 350px;
    font-size: 10px;
  }
}

@media screen and (max-width: 767px) {
  .loves_travel_inner {
    max-width: 100%;
  }

  .plan_inner {
    max-width: calc(100% / 2);
    margin-bottom: 20px;
  }
  .plan_container {
    justify-content: center;
    align-items: flex-start;
  }
}

@media screen and (max-width: 575px) {
  .loves_travel_inner {
    max-width: 100%;
  }

  .plan_inner {
    max-width: calc(100% / 1);
    margin-bottom: 20px;
  }
  .plan_container {
    justify-content: center;
    align-items: flex-start;
  }
  .loves_travel_inner h2 {
    font-size: 34px;
  }

  .tvi_w_logo img {
    max-width: 40%;
    width: 100%;
  }

  .paymnt_inner_leftts,
  .paymnt_inner_rightts {
    width: 100%;
    max-width: 100%;
    text-align: center;
  }
}

.check_out_partts h2 {
  font-size: 32px;
  font-weight: 300;
  color: rgb(50, 84, 102);
  margin-bottom: 0;
  padding-bottom: 30px;
  border-bottom: 1px solid #bdbdbd;
  text-align: left;
}

.sign_order {
  display: flex;
  /* flex-wrap: wrap; */
}

.sign_up_partts {
  max-width: 60%;
  width: 100%;
  padding: 0 30px;
}

.order_summery {
  width: 540px;
  max-width: 100%;
}
.ord_inner {
  padding: 0 20px 20px 20px;
  border: 1px solid rgb(0 0 0 / 24%);
  margin-top: 30px;
  border-radius: 20px;
}
.sign_up_partts h3 {
  font-size: 24px;
  color: #000;
  padding-bottom: 20px;
  text-align: left;
  padding-top: 20px;
}
.coupon_but {
  border: 0px;
  background: transparent;
}
.sign_up_partts p {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 20px;
  text-align: left;
  margin-top: 0px;
  padding-top: 0px;
}

.sign_login_but {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sign_buttooon {
  background-color: rgba(0, 0, 0, 0.7);
  color: rgba(255, 255, 255, 1);
  border-color: #000000;
  max-width: 48%;
  width: 100%;
  height: 40px;
  line-height: 30px;
  display: block;
  padding: 0;
}
.modal_t_field {
  appearance: none;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat 98% center;
  border: 1px solid #3b5998;
}
.login_buttooon {
  border: 1px solid rgba(0, 0, 0, 0.7);
  color: rgba(0, 0, 0, 0.7);
  max-width: 48%;
  width: 100%;
  background: #fff;
  height: 40px;
  line-height: 30px;
  display: block;
  padding: 0;
}

.addi_info {
  padding: 30px 0;
  border-top: 1px solid #dbbdbd;
  border-bottom: 1px solid #dbbdbd;
}
.addi_info h3 {
  font-size: 24px;
  color: rgb(148, 147, 147);
  text-align: left;
  margin: 0;
  padding: 0;
}

.order_summery h3 {
  font-size: 24px;
  line-height: 28px;
  color: rgb(63, 63, 63);
  padding-top: 25px;
}

.plan_summ {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 0;
}

.plan_left {
  color: rgb(53, 52, 52);
}

.plan_right {
  text-align: right;
  color: rgb(22, 18, 18);
}

.coupon_code {
  padding: 20px 0;
  border-top: 1px solid rgb(55, 54, 54);
  border-bottom: 1px solid rgb(55, 54, 54);
}

.coupon_code a {
  color: rgb(42, 39, 39);
  font-size: 15px;
  text-decoration: underline;
}

.total_amnt {
  display: flex;
  justify-content: space-between;
}

.text_l,
.text_r {
  font-size: 30px;
}

.text_r span {
  display: block;
  color: rgb(50, 49, 49);
  font-size: 14px;
}

.freetrial {
  padding-top: 20px;
  color: rgb(55, 55, 55);
  font-size: 15px;
  line-height: 22px;
}

.secure_check {
  text-align: center;
  color: rgb(54, 53, 53);
  font-size: 17px;
  padding: 14px 0;
  font-weight: 700;
}

.video_bg1.plan_bg_box:before {
  height: 180vh;
}

.modal-body h4 {
  text-align: center;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 24px;
  margin-top: 10px;
  padding-bottom: 0;
  padding-top: 0;
  text-align: center;
  color: rgb(65, 64, 64);
  font-weight: 300;
}
.modal_bodyyy {
  padding: 20px 50px;
}

.modal_bodyyy p {
  color: rgb(65, 64, 64);
  text-align: center;
  font-size: 22px;
  margin: 5px 0;
}

.modal_bodyyy p a {
  color: #000;
  text-decoration: underline;
}

.facebook_but {
  width: 100%;
  height: 45px;
  background-color: #3b5998;
  line-height: 45px;
  border: 0px;
  margin: 20px 0;
}

.google_but {
  width: 100%;
  height: 45px;
  background-color: #4285f4;
  line-height: 45px;
  border: 0px;
  margin: 10px 0;
}

.email_but {
  width: 100%;
  height: 45px;
  background-color: #225918;
  line-height: 45px;
  border: 0px;
  margin: 10px 0;
}
.facebook_but span,
.google_but span,
.email_but span {
  text-align: center;
  color: #fff;
  font-size: 15px;
  padding-left: 15px;
  font-weight: 600;
}

.or_p {
  text-align: center;
  position: relative;
}

.or_p:before {
  position: absolute;
  left: 0;
  top: 12px;
  width: 40%;
  content: "";
  position: absolute;
  height: 1px;
  background: rgb(39, 38, 38);
}

.or_p:after {
  position: absolute;
  right: 0;
  top: 12px;
  width: 40%;
  content: "";
  position: absolute;
  height: 1px;
  background: rgb(39, 38, 38);
}

.public_prf {
  text-align: center;
}

.public_prf input {
  margin-right: 10px;
}

.read_more_inner {
  text-align: center;
}
.modal-header {
  border-bottom: 0px;
}
.read_more_but {
  color: #000;
  text-decoration: underline;
}

.btn-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
  width: 24px;
  height: 24px;
  border: 0px;
}
.apply_but {
  display: block;
  width: 100%;
  border: 0px;
  height: 40px;
}
@media screen and (max-width: 767px) {
  .sign_up_partts,
  .order_summery {
    max-width: 100%;
  }
  .facebook_but span,
  .google_but span,
  .email_but span {
    font-size: 12px;
  }
}

.sign_email {
  height: 40px;
  border: 1px solid #3b5998;
}

.sign_submit {
  display: flex;
  justify-content: flex-end;
}

.sign_submit button {
  height: 50px;
  line-height: 50px;
  border-radius: 6px;
  background: #3b5998;
  color: #fff;
  padding: 0 30px;
}

.payment_boxxx {
  background: rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.sign_up_partts_update_plan.paymnt_parttss {
  max-width: 100%;
  width: 100%;
}

.sign_up_partts_update_plan {
  max-width: 100%;
  width: 100%;
  padding: 0 30px;
}
.sign_up_partts_update_plan h3 {
  font-size: 24px;
  color: #000;
  padding-bottom: 20px;
  text-align: left;
  padding-top: 20px;
}
.sign_up_partts_update_plan p {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 20px;
  text-align: left;
  margin-top: 0px;
  padding-top: 0px;
}
.card_page_logo_image {
  text-align: center;
  padding-top: 30px;
}

@media screen and (max-width: 767px) {
  .sign_up_partts_update_plan,
  .order_summery {
    max-width: 100%;
  }
  .facebook_but span,
  .google_but span,
  .email_but span {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/signup/plan.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,UAAU;AACZ;AACA;;;;;;;;;;GAUG;AACH;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;AACd;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAAuD;EACvD,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,yDAAyD;EACzD,+BAA+B;EAC/B,4BAA4B;EAC5B,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,yDAA4D;EAC5D,+BAA+B;EAC/B,4BAA4B;EAC5B,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,6EAA6E;EAC7E,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,6DAAwD;EACxD,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE;;IAEE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;AACF","sourcesContent":[".video_bg1 video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center center;\n  opacity: 1;\n  position: fixed;\n  overflow: hidden;\n}\n.plan_parts {\n  position: relative;\n  height: 100%;\n}\n\n.video_bg1 {\n  position: relative;\n  z-index: 1;\n  height: 100%;\n}\n\n.video_bg1:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n  width: 100%;\n  height: 250vh;\n  z-index: 1;\n}\n/* .overlaybg{\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0,0,0,0.3);\n    width: 100%;\n    height: 100%;\n    z-index: 9;\n} */\n.loves_travel {\n  position: absolute;\n  left: 0;\n  top: 60px;\n  right: 0;\n  bottom: 0;\n  z-index: 9;\n  width: 100%;\n  /* min-height: 600px; */\n  white-space: pre-line;\n}\n\n.loves_travel_inner {\n  max-width: 980px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.loves_travel_inner h2 {\n  text-align: center;\n  font-size: 46px;\n  color: #fff;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.tvi_w_logo {\n  text-align: center;\n  margin: 20px auto;\n}\n\n.trip_membership {\n  background: #fff;\n  border-radius: 10px;\n  padding: 60px 10px 20px 10px;\n  margin-top: 30px;\n  position: relative;\n}\n.trip_membership ._loading_overlay_overlay {\n  position: absolute;\n  top: -50px;\n  bottom: -40px;\n  height: 108%;\n}\n.trip_membership h2 {\n  font-size: 30px;\n  color: rgb(47, 46, 46);\n  text-align: center;\n  font-size: 30px;\n  font-weight: 400;\n  margin: 0;\n}\n\n.trip_membership p {\n  font-size: 30px;\n  color: rgb(47, 46, 46);\n  text-align: center;\n  font-size: 24px;\n  font-weight: 400;\n  margin: 20px 0 0 0;\n}\n\n.tvi_plan {\n  margin-top: 60px;\n}\n\n.plan_container {\n  margin: 0 -20px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.plan_inner {\n  max-width: calc(100% / 3);\n  width: 100%;\n  padding: 0 20px;\n}\n\n.plan_inner_inner {\n  flex: 0 1 auto;\n  flex-direction: column;\n  height: 100%;\n  border: 1px solid rgba(47, 46, 46, 0.2);\n}\n\n.trip_inner_membership {\n  background: rgba(176, 55, 55, 0.1);\n  padding: 30px;\n  position: relative;\n}\n.spot {\n  height: 30px;\n  line-height: 30px;\n  padding: 0 10px;\n  background: rgb(176, 55, 55);\n  position: absolute;\n  left: 50%;\n  top: -20px;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  color: #fff;\n  font-weight: 500;\n  font-size: 12px;\n}\n.trip_inner_membership h2 {\n  text-align: center;\n  color: rgb(47, 46, 46);\n  font-size: 20px;\n  line-height: 1.4em;\n  padding-bottom: 12px;\n  text-decoration: none;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.sign_up_partts.paymnt_parttss {\n  max-width: 100%;\n  width: 100%;\n}\n\n.check_out_partts .paymnt_text h2 {\n  text-align: center;\n  font-size: 32px;\n  font-weight: 600;\n  color: rgb(14, 223, 73);\n  margin: 0;\n}\n.price_plan span {\n  font-size: 18px !important;\n  line-height: 1 !important;\n  margin-right: 2px;\n  vertical-align: top;\n  display: inline-block;\n}\n\n.paymnt_type {\n  max-width: 100%;\n  width: 100%;\n}\n.paymn_success {\n  text-align: center;\n}\n.paymnt_inner_type {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 20px 0 10px 0;\n  max-width: 60%;\n  margin: auto;\n  width: 100%;\n}\n\n.paymnt_inner_rightts {\n  text-align: right;\n  font-weight: 600;\n  font-size: 16px;\n  color: #000;\n  width: 50%;\n  word-break: break-all;\n}\n\n.paymnt_inner_leftts {\n  text-align: left;\n  font-weight: 400;\n  font-size: 16px;\n  color: #5b5959;\n  width: 50%;\n}\n.price_plan {\n  color: rgb(47, 46, 46);\n  line-height: 1.1 !important;\n  font-size: 80px;\n  font-weight: 300;\n}\n\n.membership_two {\n  color: rgb(47, 46, 46);\n  font-size: 14px !important;\n  line-height: 20px !important;\n  text-align: center;\n  margin-top: 30px;\n}\n\n.validity {\n  margin-top: 30px;\n  color: rgb(176, 170, 169);\n  font-size: 12px !important;\n  line-height: 1 !important;\n  text-align: center;\n}\n\n.lock_button {\n  text-align: center;\n  margin-top: 30px;\n}\n\n.lock_button_partts {\n  background-color: rgba(50, 84, 102, 1);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0);\n  border-width: 1px;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 10px;\n  padding: 0 10px;\n  color: #fff;\n  font-weight: 600;\n  display: inline-block;\n  font-size: 12px;\n  max-width: 300px;\n  width: 100%;\n}\n\n.lock_button_partts:hover {\n  text-decoration: none;\n  background-color: rgba(50, 84, 102, 0.7);\n  color: #fff;\n}\n\n.plan_offer {\n  padding: 20px;\n  margin: 0px;\n}\n\n.plan_offer li {\n  list-style-type: none;\n  font-size: 13px;\n  padding: 10px 20px 10px 20px;\n  position: relative;\n}\n\n.plan_offer li:before {\n  content: \"\";\n  position: absolute;\n  background: url(../../assets/images/tick.png) no-repeat;\n  left: 0;\n  top: 10px;\n  width: 24px;\n  height: 24px;\n}\n.valid .form-control {\n  background-image: url(../../assets/images/green_tick.png);\n  background-position: 98% center;\n  background-repeat: no-repeat;\n  box-shadow: 0 0 5px rgba(40, 246, 24, 0.3);\n  border: 1px solid #28f618;\n}\n\n.invalid .form-control {\n  background-image: url(../../assets/images/invalid_cross.png);\n  background-position: 98% center;\n  background-repeat: no-repeat;\n  box-shadow: 0 0 5px rgba(244, 11, 11, 0.3);\n  border: 1px solid #f40b0b;\n}\n@media screen and (max-width: 991px) {\n  .price_plan {\n    font-size: 40px;\n  }\n  .trip_inner_membership {\n    padding: 10px;\n  }\n  .lock_button_partts {\n    max-width: 350px;\n    font-size: 10px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .loves_travel_inner {\n    max-width: 100%;\n  }\n\n  .plan_inner {\n    max-width: calc(100% / 2);\n    margin-bottom: 20px;\n  }\n  .plan_container {\n    justify-content: center;\n    align-items: flex-start;\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .loves_travel_inner {\n    max-width: 100%;\n  }\n\n  .plan_inner {\n    max-width: calc(100% / 1);\n    margin-bottom: 20px;\n  }\n  .plan_container {\n    justify-content: center;\n    align-items: flex-start;\n  }\n  .loves_travel_inner h2 {\n    font-size: 34px;\n  }\n\n  .tvi_w_logo img {\n    max-width: 40%;\n    width: 100%;\n  }\n\n  .paymnt_inner_leftts,\n  .paymnt_inner_rightts {\n    width: 100%;\n    max-width: 100%;\n    text-align: center;\n  }\n}\n\n.check_out_partts h2 {\n  font-size: 32px;\n  font-weight: 300;\n  color: rgb(50, 84, 102);\n  margin-bottom: 0;\n  padding-bottom: 30px;\n  border-bottom: 1px solid #bdbdbd;\n  text-align: left;\n}\n\n.sign_order {\n  display: flex;\n  /* flex-wrap: wrap; */\n}\n\n.sign_up_partts {\n  max-width: 60%;\n  width: 100%;\n  padding: 0 30px;\n}\n\n.order_summery {\n  width: 540px;\n  max-width: 100%;\n}\n.ord_inner {\n  padding: 0 20px 20px 20px;\n  border: 1px solid rgb(0 0 0 / 24%);\n  margin-top: 30px;\n  border-radius: 20px;\n}\n.sign_up_partts h3 {\n  font-size: 24px;\n  color: #000;\n  padding-bottom: 20px;\n  text-align: left;\n  padding-top: 20px;\n}\n.coupon_but {\n  border: 0px;\n  background: transparent;\n}\n.sign_up_partts p {\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 20px;\n  text-align: left;\n  margin-top: 0px;\n  padding-top: 0px;\n}\n\n.sign_login_but {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.sign_buttooon {\n  background-color: rgba(0, 0, 0, 0.7);\n  color: rgba(255, 255, 255, 1);\n  border-color: #000000;\n  max-width: 48%;\n  width: 100%;\n  height: 40px;\n  line-height: 30px;\n  display: block;\n  padding: 0;\n}\n.modal_t_field {\n  appearance: none;\n  background: #fff url(../../assets/images/down-arrow.png) no-repeat 98% center;\n  border: 1px solid #3b5998;\n}\n.login_buttooon {\n  border: 1px solid rgba(0, 0, 0, 0.7);\n  color: rgba(0, 0, 0, 0.7);\n  max-width: 48%;\n  width: 100%;\n  background: #fff;\n  height: 40px;\n  line-height: 30px;\n  display: block;\n  padding: 0;\n}\n\n.addi_info {\n  padding: 30px 0;\n  border-top: 1px solid #dbbdbd;\n  border-bottom: 1px solid #dbbdbd;\n}\n.addi_info h3 {\n  font-size: 24px;\n  color: rgb(148, 147, 147);\n  text-align: left;\n  margin: 0;\n  padding: 0;\n}\n\n.order_summery h3 {\n  font-size: 24px;\n  line-height: 28px;\n  color: rgb(63, 63, 63);\n  padding-top: 25px;\n}\n\n.plan_summ {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 10px 0;\n}\n\n.plan_left {\n  color: rgb(53, 52, 52);\n}\n\n.plan_right {\n  text-align: right;\n  color: rgb(22, 18, 18);\n}\n\n.coupon_code {\n  padding: 20px 0;\n  border-top: 1px solid rgb(55, 54, 54);\n  border-bottom: 1px solid rgb(55, 54, 54);\n}\n\n.coupon_code a {\n  color: rgb(42, 39, 39);\n  font-size: 15px;\n  text-decoration: underline;\n}\n\n.total_amnt {\n  display: flex;\n  justify-content: space-between;\n}\n\n.text_l,\n.text_r {\n  font-size: 30px;\n}\n\n.text_r span {\n  display: block;\n  color: rgb(50, 49, 49);\n  font-size: 14px;\n}\n\n.freetrial {\n  padding-top: 20px;\n  color: rgb(55, 55, 55);\n  font-size: 15px;\n  line-height: 22px;\n}\n\n.secure_check {\n  text-align: center;\n  color: rgb(54, 53, 53);\n  font-size: 17px;\n  padding: 14px 0;\n  font-weight: 700;\n}\n\n.video_bg1.plan_bg_box:before {\n  height: 180vh;\n}\n\n.modal-body h4 {\n  text-align: center;\n  font-size: 48px;\n  line-height: 48px;\n  margin-bottom: 24px;\n  margin-top: 10px;\n  padding-bottom: 0;\n  padding-top: 0;\n  text-align: center;\n  color: rgb(65, 64, 64);\n  font-weight: 300;\n}\n.modal_bodyyy {\n  padding: 20px 50px;\n}\n\n.modal_bodyyy p {\n  color: rgb(65, 64, 64);\n  text-align: center;\n  font-size: 22px;\n  margin: 5px 0;\n}\n\n.modal_bodyyy p a {\n  color: #000;\n  text-decoration: underline;\n}\n\n.facebook_but {\n  width: 100%;\n  height: 45px;\n  background-color: #3b5998;\n  line-height: 45px;\n  border: 0px;\n  margin: 20px 0;\n}\n\n.google_but {\n  width: 100%;\n  height: 45px;\n  background-color: #4285f4;\n  line-height: 45px;\n  border: 0px;\n  margin: 10px 0;\n}\n\n.email_but {\n  width: 100%;\n  height: 45px;\n  background-color: #225918;\n  line-height: 45px;\n  border: 0px;\n  margin: 10px 0;\n}\n.facebook_but span,\n.google_but span,\n.email_but span {\n  text-align: center;\n  color: #fff;\n  font-size: 15px;\n  padding-left: 15px;\n  font-weight: 600;\n}\n\n.or_p {\n  text-align: center;\n  position: relative;\n}\n\n.or_p:before {\n  position: absolute;\n  left: 0;\n  top: 12px;\n  width: 40%;\n  content: \"\";\n  position: absolute;\n  height: 1px;\n  background: rgb(39, 38, 38);\n}\n\n.or_p:after {\n  position: absolute;\n  right: 0;\n  top: 12px;\n  width: 40%;\n  content: \"\";\n  position: absolute;\n  height: 1px;\n  background: rgb(39, 38, 38);\n}\n\n.public_prf {\n  text-align: center;\n}\n\n.public_prf input {\n  margin-right: 10px;\n}\n\n.read_more_inner {\n  text-align: center;\n}\n.modal-header {\n  border-bottom: 0px;\n}\n.read_more_but {\n  color: #000;\n  text-decoration: underline;\n}\n\n.btn-close {\n  background: url(../../assets/images/cross.png) no-repeat;\n  width: 24px;\n  height: 24px;\n  border: 0px;\n}\n.apply_but {\n  display: block;\n  width: 100%;\n  border: 0px;\n  height: 40px;\n}\n@media screen and (max-width: 767px) {\n  .sign_up_partts,\n  .order_summery {\n    max-width: 100%;\n  }\n  .facebook_but span,\n  .google_but span,\n  .email_but span {\n    font-size: 12px;\n  }\n}\n\n.sign_email {\n  height: 40px;\n  border: 1px solid #3b5998;\n}\n\n.sign_submit {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.sign_submit button {\n  height: 50px;\n  line-height: 50px;\n  border-radius: 6px;\n  background: #3b5998;\n  color: #fff;\n  padding: 0 30px;\n}\n\n.payment_boxxx {\n  background: rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.sign_up_partts_update_plan.paymnt_parttss {\n  max-width: 100%;\n  width: 100%;\n}\n\n.sign_up_partts_update_plan {\n  max-width: 100%;\n  width: 100%;\n  padding: 0 30px;\n}\n.sign_up_partts_update_plan h3 {\n  font-size: 24px;\n  color: #000;\n  padding-bottom: 20px;\n  text-align: left;\n  padding-top: 20px;\n}\n.sign_up_partts_update_plan p {\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 20px;\n  text-align: left;\n  margin-top: 0px;\n  padding-top: 0px;\n}\n.card_page_logo_image {\n  text-align: center;\n  padding-top: 30px;\n}\n\n@media screen and (max-width: 767px) {\n  .sign_up_partts_update_plan,\n  .order_summery {\n    max-width: 100%;\n  }\n  .facebook_but span,\n  .google_but span,\n  .email_but span {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
